
export enum ISeoTagType {
  Title, Description, Keywords
}
